<template>
    <div class="ticket-kanban-board">
        <!-- Scroll butonları -->
        <div v-if="showScrollRightButton" class="scroll-right-task" @click="scrollRight">→</div>
        <div v-if="showScrollLeftButton" class="scroll-left-task" @click="scrollLeft">←</div>
        <!-- Kanban Board -->
        <div class="drag-container">
            <TicketColumnCard
                v-for="(group, index) in groups"
                :key="group._id"
                :group="group"
                @update-ticket-status="handleUpdateTicketStatus"
                @toggle-ticket-selection="handleToggleTicketSelection"
                @toggle-select-all="handleToggleSelectAll"
                @ticket-clicked="handleTicketClicked"
                :selectedTickets="selectedTickets"
                :dndEnabled="index !== 0"
            />
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import TicketColumnCard from "./TicketColumnCard.vue";

export default Vue.extend({
    name: "TicketKanbanBoard",
    components: {
        TicketColumnCard,
    },
    props: {
        tickets: {
            type: Array,
            required: true,
        },
        statusList: {
            type: Array,
            required: true,
        },
        selectedTickets: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            showScrollRightButton: false,
            showScrollLeftButton: false,
            ticketGroupDragOptions: {
                group: "tickets",
                animation: 200,
                sort: false,
                handle: ".ticket-item",
            },
            groups: [],
            moving: false,
        };
    },
    methods: {
        handleMouseMove(event) {
            // Scroll butonlarının görünürlüğünü ayarlar
        },
        scrollRight() {
            const container = document.querySelector(".ticket-kanban-board");
            container.scrollBy({
                top: 0,
                left: 100,
                behavior: "smooth",
            });
            this.showScrollLeftButton = true;

            setTimeout(() => {
                if (container.scrollWidth <= container.scrollLeft + container.clientWidth + 100) {
                    this.showScrollRightButton = false;
                }
            }, 1000);
        },
        scrollLeft() {
            const container = document.querySelector(".ticket-kanban-board");
            container.scrollBy({
                top: 0,
                left: -100,
                behavior: "smooth",
            });

            setTimeout(() => {
                if (container.scrollLeft <= 100) {
                    this.showScrollLeftButton = false;
                } else {
                    this.showScrollRightButton = true;
                }
            }, 3000);
        },
        moveStatusEnd(event) {
            this.moving = false;
            // Durum sütunlarının yerini günceller
            // Gerekli API çağrıları veya store güncellemeleri burada yapılabilir
        },
        groupTicketsByStatus() {
            this.groups = this.statusList.map((status) => ({
                _id: status._id,
                title: status.title,
                tickets: this.tickets.filter((ticket) => ticket.status === status.title),
            }));
            this.groups = [
                {
                    _id: null,
                    title: this.$t("ticket.unprocessed"),
                    tickets: this.tickets.filter((ticket) => !ticket.status),
                },
                ...this.groups,
            ];
        },
        handleUpdateTicketStatus({ ticketId, statusTitle }) {
            // Ticket'ın status'unu güncelle
            const ticket = this.tickets.find((t) => t._id === ticketId);
            if (ticket) {
                ticket.status = statusTitle;
            }
            // Üst bileşene bildir
            this.$emit("update-ticket-status", { ticketId, statusTitle });
        },
        handleToggleTicketSelection(ticketId) {
            this.$emit('toggle-ticket-selection', ticketId);
        },
        handleToggleSelectAll(columnTickets) {
            this.$emit('toggle-select-all', columnTickets);
        },
        handleTicketClicked(ticket) {
            this.$emit('ticket-clicked', ticket);
        },
    },
    watch: {
        tickets: {
            handler() {
                this.groupTicketsByStatus();
            },
            immediate: true,
        },
        statusList: {
            handler() {
                this.groupTicketsByStatus();
            },
            immediate: true,
        },
    },
});
</script>

<style lang="scss">
.ticket-kanban-board {
    padding: 10px;
    overflow: auto;
    width: calc(100vw - 185px);
    transition: 1s all;
    height: 100%;
    display: flex;

    .scroll-right-task,
    .scroll-left-task {
        position: fixed;
        top: 50%;
        background-color: #ec4b1d;
        color: white;
        border: none;
        padding: 10px;
        cursor: pointer;
        z-index: 1000;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        width: 60px;
    }

    .scroll-right-task {
        right: 10px;
    }

    .scroll-left-task {
        left: 150px !important;
        z-index: 1;
    }

    &::-webkit-scrollbar {
        display: none;
        height: 0;
    }

    .drag-container {
        display: flex;
        gap: 10px;
        height: 100%;
    }

    .supsis-draggable {
        display: flex;
        gap: 10px;
        height: 100%;
    }
}
</style>
